import Model from '@/models/Model.js';

export default class ModelRole extends Model {
    static entity = 'model_has_roles';

    static primaryKey = ['role_id', 'model_id', 'model_type'];

    static fields() {
        return {
            role_id: this.attr(null),
            model_type: this.attr(null),
            model_type_entity: this.attr(null),
            model_id: this.attr(null),
        };
    }

    /**
     * @param {ModelRole} model
     * @returns {boolean|void}
     */
    static beforeCreate(model) {
        if (model.hasDuplicateRecord) {
            return false;
        }
    }

    /**
     * @param {ModelRole} model
     * @returns {boolean|void}
     */
    static beforeUpdate(model) {
        if (model.hasDuplicateRecord) {
            return false;
        }
    }

    /**
     * @param {ModelRole} model
     * @returns {?ModelRole}
     */
    static findDuplicateRecordFor(model) {
        return (
            ModelRole.query().whereId([model.role_id, model.model_id, model.model_type]).first() ??
            ModelRole.query()
                .where('role_id', model.role_id)
                .where('model_id', model.model_id)
                .where('model_type', model.model_type)
                .first()
        );
    }

    /**
     * @returns {?ModelRole}
     */
    get duplicateRecord() {
        return ModelRole.findDuplicateRecordFor(this);
    }

    /**
     * @returns {boolean}
     */
    get hasDuplicateRecord() {
        return this.duplicateRecord !== null;
    }
}
